import React from "react";
import { Helmet } from "react-helmet";
import { useLocation, matchPath } from "react-router-dom";

const BASE_URL = "https://kheloindore.in";

const indexableRoutes = [
  "/",
  "/sports-venue",
  "/sports-venue/:type",
  "/sports-venue/:type/:name/:id",
  "/coaches",
  "/coaches/all",
  "/coaches/categories",
  "/coaches/category/:type",
  "/coaches/:type/:name/:id",
  "/trainers",
  "/trainers/category/:type",
  "/trainers/trainer/:name/:id",
  "/blog", "/blog/:slugName",
  "/events",
  "/events/event-details/:id",
  "/pages/about-us",
  "/contact-us",
  "/terms-condition",
  "/privacy-policy",
  "/refund-policy",
  "/pages/faq",
  "/pages/services",
  "/pages/service-detail",
  "/pages/pricing",
  "/pages/our-teams",
  "/pages/gallery",
  "/pages/testimonials",
];

const excludedRoutes = [
  "/blog/blog-grid-sidebar-right",
  "/blog/blog-grid-sidebar-left",
  "/blog/blog-list-sidebar-right",
  "/blog/blog-carousel",
];

const CanonicalTag = () => {
  const { pathname } = useLocation();

  const isExcluded = excludedRoutes.includes(
    pathname.replace(/\/+$/, "") || "/"
  );

  const isIndexable = !isExcluded && indexableRoutes.some((route) =>
    matchPath({ path: route, end: true }, pathname)
  );

  if (!isIndexable) return null;

  const normalizedPath =
    pathname === "/" ? "/" : pathname.replace(/\/+$/, "");

  const canonicalUrl = `${BASE_URL}${normalizedPath}`;

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default CanonicalTag;
